import { Capacitor } from "@capacitor/core";
import { initializeApp, getApp, getApps } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithCustomToken,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import config from "../../config";

const raw = JSON.parse(config.FIREBASE);
const firebaseConfig = !Capacitor.isNativePlatform()
  ? { ...raw, authDomain: "auth.visitoai.com" }
  : raw;

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const db = getFirestore(app);

const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

const googleProvider = new GoogleAuthProvider();

const microsoftProvider = new OAuthProvider("microsoft.com");

const signInWithToken = async (token: string) => {
  return await signInWithCustomToken(auth, token);
};

export { app, auth, googleProvider, microsoftProvider, db, signInWithToken };
